export enum BooleanSelectOption {
  True = 'true',
  False = 'false',
}

export const convertBooleanSelectOptionToBoolean = (
  option: BooleanSelectOption | undefined,
): boolean | undefined => {
  if (option === BooleanSelectOption.True) return true

  return false
}

export const convertBooleanToBooleanSelectOption = (
  value: boolean | undefined | null,
): BooleanSelectOption | undefined => {
  if (value === true) return BooleanSelectOption.True
  return BooleanSelectOption.False
}
